import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import * as yup from 'yup';

import { useFormState } from 'shared/hooks';

import { FlexBoxAlign } from 'styles/layout';
import { FilterElement } from 'features/admin/pages/Consults/ConsultList/ConsultListFilters/ConsultFilters.style';
import FacilitySelect from 'shared/components/data/forms/FacilitySelect';
import HealthSystemSelect from 'shared/components/data/forms/HealthSystemSelect';

const schema = yup.object().shape({});

const ListFilters = ({ onFilterChanged }) => {
  const { control, handleSubmit, watch, setValue } = useFormState(schema);

  const healthSystem = watch('healthSystemId');
  const facilityId = watch('facilityId');
  
  const previousHealthSystemId = useRef(healthSystem);

  useEffect(() => {
    if (previousHealthSystemId.current !== healthSystem) {
      previousHealthSystemId.current = healthSystem;

      if (facilityId) {
        setValue('facilityId', null);
        onFilterChanged({ healthSystem, facilityId: null });
      }
    }
  }, [healthSystem, facilityId, setValue, onFilterChanged]);

  return (
    <FlexBoxAlign flexWrap="wrap">
      <FilterElement>
        <HealthSystemSelect
          control={control}
          name="healthSystemId"
          handleChange={handleSubmit(onFilterChanged)}
        />
      </FilterElement>
      <FilterElement>
        <FacilitySelect
          control={control}
          name="facilityId"
          handleChange={handleSubmit(onFilterChanged)}
          healthSystem={healthSystem}
          requiredSystem
        />
      </FilterElement>
    </FlexBoxAlign>
  );
};

ListFilters.propTypes = {
  onFilterChanged: PropTypes.func,
};

export default ListFilters;
